"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadInvoiceLines = exports.UcInvoiceLines = void 0;
const UcInvoiceLines_yaml_component_1 = __importDefault(require("./UcInvoiceLines.yaml?component"));
exports.UcInvoiceLines = UcInvoiceLines_yaml_component_1.default;
const UploadInvoiceLines_yaml_component_1 = __importDefault(require("./UploadInvoiceLines.yaml?component"));
exports.UploadInvoiceLines = UploadInvoiceLines_yaml_component_1.default;
